import { render, staticRenderFns } from "./MenuSelect.html?vue&type=template&id=35a3381b&external"
import script from "./MenuSelect.vue?vue&type=script&lang=js"
export * from "./MenuSelect.vue?vue&type=script&lang=js"
import style0 from "./MenuSelect.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports